import React from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import BusinessRegistration from '../../components/BusinessRegistration';
  

const BusinessRegistrationPage = () => {

  return (
    <>  
      <LoginHeader />
      <main>
        <BusinessRegistration />
      </main>
      <LoginFooter />
    </>
  )
}

export default BusinessRegistrationPage;